import { render } from "./ValidateShipping.vue?vue&type=template&id=f6af7022&scoped=true"
import script from "./ValidateShipping.vue?vue&type=script&lang=js"
export * from "./ValidateShipping.vue?vue&type=script&lang=js"

import "./ValidateShipping.vue?vue&type=style&index=0&id=f6af7022&scoped=true&lang=css"
import "./ValidateShipping.vue?vue&type=style&index=1&id=f6af7022&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6af7022"]])

export default __exports__